import React from 'react'
import { get } from 'lodash'
import { Col, Container, Row } from 'react-bootstrap'

import SectionTitleModule from 'components/molecules/SectionTitle'

function SectionTitle({ data }) {
  return (
    <Container fluid className="section-title mt-5">
      <Container>
        <Row>
          <Col lg={4}>
            <SectionTitleModule textColor="gray-100" title={get(data, 'title')} />
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default SectionTitle
